<template>
    <div>
          <div class="innerSearch">
                <div class="box">
                    <input ref="keyword" class="search-input" type="text" placeholder="请输入关键词">
                    <a href="javascript:void(0)" @click="ClickSearch()">搜索</a>
                </div>
            </div>
           <div class="selectfilter">
                <FlatSelectFilter title="类型" v-model="selected_category" :options="list_category" />
                <FlatSelectFilter title="行业" v-model="selected_hangye" :options="list_hangye" />
            </div>

            <div class="demandCon">
                 <div class="list purchase">
                      <div class="tableTh">
                           <span class="text_info">采购信息</span>
                           <span class="text_type">类型</span>
                           <span class="text_address">交货地点</span>
                           <span class="text_state">状态</span>
                           <span class="operate">操作</span>
                      </div>
                      <template v-if="total==0">
                        <div class="nodataTip">
                            <div class="ico">
                                <img src="../../assets/images/nodataTip.png" alt="">
                            </div>
                            <div class="text">暂无数据~</div>
                        </div>
                     </template>
                      <ul>
                         <template v-for="(item,index) in list_demand">
                         <li :key="index">
                          <router-link :to="{name:'demanddetail',params:{id:item.id} }">
                            <div class="tabCell text_info">
                                    
                                    <div class="title">{{item.title}}</div>
                                    <div class="desc">{{item.zhaiyao}}</div>
                                    <div class="time">发布时间：{{item.add_time_str}}</div>
    
                            </div>
                            <div class="tabCell text_type">
                                    <span>{{item.category_str}}需求</span>
                            </div>
                             <div class="tabCell text_address">
                                    <span>{{item.location?item.location:'--'}}</span>
                            </div>
                             <div class="tabCell text_state">
                                    <span>{{item.demand_status_str}}</span>
                            </div>
                            <div class="tabCell operate">
                                  <div class="dataShow">
                                      <span><b>{{item.click}}</b>浏览</span>
                                  </div>
                            </div>
                          </router-link>
                         </li>

                         </template>
                      </ul>
                 </div>
                  <Pagination v-model="pageindex" :total="total" :pagesize="pagesize" v-if="total>6" />
            </div>
             
    </div>
</template>
<script>
// import {Input,Loading } from 'element-ui';
import FlatSelectFilter from '../../components/Common/FlatSelectFilter'
import Pagination from '../../components/Common/Pagination'
import $ from 'jquery'
export default {
  data(){
    return{
        list_hangye:[],
        selected_hangye:this.$route.params.tag,
        list_category: [],
        selected_category: 0,
        keyword:'',
        list_demand:[],
        total:0,
        pagesize:6,
        pageindex: 1,
    }
  },
  created(){
    this.GetList();
    this.GetHangye();
    this.GetCategory();
  },
  mounted:function(){
      
    },
  components:{
    // [Input.name]:Input,
    FlatSelectFilter,
    Pagination
  },
  methods:{
     GetList(){
            // this.loadingInstance = Loading.service({
            //     // 动画中的文字
            //     text:'加载中',
            //     // 要加载动画的容器
            //     target:'.app-container'
            // });
            var url = "https://api.xincailiao.com/Open/GetPurchaseDemandList";
            this.$http.post(url,{
                type:1,
                pageindex:this.pageindex,
                pagesize:this.pagesize,
                keyword:this.keyword,
                hangye:this.selected_hangye,
                category:this.selected_category
                }).then(function(res){
                if (res.data.status==1){
                    this.list_demand = res.data.ds;
                    this.total = res.data.total;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){});
        },
        GetHangye() {
            var url = "https://api.xincailiao.com/Open/GetCategoryTags";
            this.$http.post(url, { type: 6 }).then((res) => {
                if (res.data.status == 1) {
                    var temp = [{ item: "全部", value: 0 }];
                    res.data.ds.map((item) => {
                    temp.push({ item: item.tag, value: item.tag });
                    });
                    this.list_hangye = temp;
                }
                })
                .catch(() => {});
            },
        GetCategory() {
            var url = "https://api.xincailiao.com/Open/GetPurchaseDemandCategory";
            this.$http.post(url, { type: 1 }).then((res) => {
                if (res.data.status == 1) {
                    var temp = [{ item: "全部", value: 0 }];
                    res.data.ds.map((item) => {
                    temp.push({ item: item.title, value: item.id });
                    });
                    this.list_category = temp;
                }
                })
                .catch(() => {});
        },
         ClickSearch: function () {
            this.keyword = $(this.$refs.keyword).val();
        },
        PropsChange() {
            if (this.pageindex!=1){
            this.pageindex=1;
            }else{
            this.GetList();
            }
        },
    },
    watch:{
        pageindex:function(){
            this.GetList();
        },
        keyword(){
            this.PropsChange();
        },
        selected_hangye(){
           this.PropsChange();
        }, 
        selected_category(){
            this.PropsChange();
        } 
    }
}
</script>
